<template>
  <div id="my__projects">
    <HeaderControlsProject :myWeek='false'  :namespace="namespace" />
    <div class="container-fluid">
        <MyProjectsList  :namespace="namespace"/>
    </div>
  </div>
</template>

<script>
import MyProjectsList from "../components/deliverables/MyProjectsList";
import HeaderControlsProject from "../components/common/HeaderControlsProject";
import { mapActions } from 'vuex';
export default {
	data() {
		return {
			namespace:""
		}
	},
    components: {
        MyProjectsList,
        HeaderControlsProject
    },
    methods: {
      ...mapActions(['fetchUserProjects'])
    },
    mounted() {
      this.fetchUserProjects();
    }
}
</script>

<style>

</style>